import { defineStore } from 'pinia'

export const useErrorStore = defineStore('error', {
  state: () => ({
    title: '',
    message: '',
    hasError: false,
  }),
  actions: {
    setError(title: string, message: string) {
      this.title = title
      this.message = message
      this.hasError = true

      // セッションストレージにも保存
      sessionStorage.setItem(
        'app_error',
        JSON.stringify({
          title,
          message,
          hasError: true,
        }),
      )
    },

    clearError() {
      this.title = ''
      this.message = ''
      this.hasError = false
      sessionStorage.removeItem('app_error')
    },

    loadErrorFromSession() {
      const data = sessionStorage.getItem('app_error')
      if (data) {
        const parsed = JSON.parse(data)
        this.title = parsed.title
        this.message = parsed.message
        this.hasError = parsed.hasError
      }
    },
  },
})
